export * from './svedTargetDossier.component';
export * from './svedTargetDossier.service';
